import type {SVGProps} from 'react';

export const EnvelopeIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={45}
		height={45}
		fill="none"
		viewBox="0 0 45 45"
		{...props}
	>
		<g filter="url(#a)">
			<rect width={36.176} height={36.176} x={4} fill="#fff" rx={10.853} />
			<path
				fill="#125585"
				fillRule="evenodd"
				d="M26.3 9.044c3.012 0 5.283 2.457 5.283 5.716v6.211c0 1.668-.59 3.174-1.661 4.244-.962.957-2.209 1.465-3.607 1.465h-8.911c-1.395 0-2.642-.507-3.604-1.465-1.072-1.07-1.661-2.576-1.661-4.244V14.76c0-3.259 2.27-5.716 5.282-5.716h8.88Zm0 1.356h-8.879c-2.274 0-3.926 1.834-3.926 4.36v6.211c0 1.305.449 2.47 1.263 3.282.702.701 1.618 1.07 2.649 1.07H26.3c.001-.002.009 0 .014 0 1.032 0 1.947-.369 2.649-1.07.815-.811 1.263-1.977 1.263-3.282V14.76c0-2.526-1.652-4.36-3.926-4.36Zm1.426 4.187a.679.679 0 0 1-.099.954l-4.019 3.267a2.75 2.75 0 0 1-3.436.005l-4.056-3.27a.68.68 0 0 1 .851-1.057l4.053 3.267c.509.403 1.226.403 1.739-.004l4.012-3.26a.678.678 0 0 1 .955.098Z"
				clipRule="evenodd"
			/>
		</g>
		<defs>
			<filter
				id="a"
				width={44.176}
				height={44.176}
				x={0}
				y={0}
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
			>
				<feFlood floodOpacity={0} result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset dy={4} />
				<feGaussianBlur stdDeviation={2} />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
				<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_713_7187" />
				<feBlend in="SourceGraphic" in2="effect1_dropShadow_713_7187" result="shape" />
			</filter>
		</defs>
	</svg>
);
